"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Funções necessárias para renderizar os componentes de forma dinâmica
 */
/* eslint-disable import/no-anonymous-default-export */
var react_1 = __importStar(require("react"));
//icons
require("../../assets/style.css");
//Os componentes totais que podem ser renderizados
var PPGrid_1 = require("./PPGrid");
var PPTextField_1 = require("../PPTextField/PPTextField");
var PP_DropDownOld_1 = __importDefault(require("../PP_DropDownOld/PP_DropDownOld"));
var PPDialog_1 = require("../PPDialog/PPDialog");
var PPUploader_1 = require("../PPUploader/PPUploader");
/**
 * Tratamento do nome dos componentes no Json
 * O nome à direita deve ser como estará referenciado no Json
 * O nome à esquerda deve ser o nome real do componente.
 */
var Components = {
    PPTextField: PPTextField_1.PPTextField,
    PPGrid: PPGrid_1.PPGrid,
    PP_DropDownOld: PP_DropDownOld_1.default,
    PPDialog: PPDialog_1.PPDialog,
    PPUploader: PPUploader_1.PPUploader,
};
/**
 * Função para renderizar o componente de forma dinâmica
 * @param component Item com a estrutura do componente atual do map, de acordo com o JSON de estruturação
 * @returns Componente renderizado seguindo seus atributos
 */
var renderComponent = function (_a, fields, readOnly, disabled) {
    var componentClass = _a.class, required = _a.required, alignItems = _a.alignItems, justifyContent = _a.justifyContent, contents = _a.contents, direction = _a.direction, placeholder = _a.placeholder, component = __rest(_a, ["class", "required", "alignItems", "justifyContent", "contents", "direction", "placeholder"]);
    var ppgrid = "PPGrid";
    var disabledComponent = disabled ? true : component.disabled;
    var readOnlyComponent = readOnly ? true : component.readOnly;
    switch (componentClass) {
        case "undefined":
            return (0, react_1.createElement)(function () { return react_1.default.createElement("div", null,
                " The component ",
                componentClass,
                " does not exist"); }, { key: component.id });
        case ppgrid:
            return (0, react_1.createElement)(PPGrid_1.PPGrid, {
                direction: direction,
                contents: contents,
                justifyContent: justifyContent,
                alignItems: alignItems,
                readOnly: readOnly,
                disabled: disabled,
                fields: fields,
                className: undefined,
            });
        default:
            return (0, react_1.createElement)(Components[componentClass], __assign(__assign({ key: component.id }, component), { required: required, disabled: disabledComponent, readOnly: readOnlyComponent, placeholder: placeholder }));
    }
};
exports.default = renderComponent;
